export async function efficiencyYBIUseCase(client_id, period, year, month, shipping_service, yegoDashboardRepository) {
    const result = await yegoDashboardRepository.efficiencyYBI(client_id, period, year, month, shipping_service);
    
    const info = await new yegoDashboardRepository.efficiency_model(result.data.data);

    if (!info.isValid()) {
        throw new Error("Smart Carrier Answer Inválido");
    }

    return result.data.data;
}